(function ($, Drupal) {

  Drupal.behaviors.expandableForm = {
    attach: function () {
      let $form = $('.views-exposed-form');

      if ($form.length > 0) {
        if ($form.find('[type="checkbox"]').length > 0) {
          let $check = $form.find('[type="checkbox"]:disabled');

          $check.each(function () {
            if (sessionStorage.getItem('check-expanded' + $(this).attr('id') + '') == 'true') {
              $(this).prop('checked', true);
            };

            if ($(this).siblings('.fieldset-wrapper').children().find(':checked').length > 0) {
              $(this).prop('checked', true);
            };

            $(this).next().on('click', function () {
              if ($(this).prev().prop('checked') == true) {
                $(this).prev().prop('checked', false);

                sessionStorage.setItem('check-expanded' + $(this).prev().attr('id') + '', false);
              } else {
                $(this).prev().prop('checked', true);

                sessionStorage.setItem('check-expanded' + $(this).prev().attr('id') + '', true);
              }
            })
          });
        }
      };
    }
  }
}(jQuery, Drupal));
